import script from "./NoticeBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeBoard.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeBoard.vue?vue&type=style&index=0&id=46e0e564&scoped=true&lang=scss"

import exportComponent from "/ws/483d663ba9f2473cb9ed84f25e5f2ea6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e0e564"]])

export default __exports__